import React from 'react';

type ValueChangeProps = {
  value?: string;
  raw?: number;
};
function ValueChange({ value, raw = 0 }: ValueChangeProps) {
  return <span className={`text-xs ${raw < 0 ? 'text-ui-red' : 'text-ui-green'}`}>{value || <span>&nbsp;</span>}</span>;
}

export { ValueChange };
